export default [
    {
        path: '/ticketing',
        meta: {
            title: "IT Ticket",
            icon: "ticketing-support.png",
            show: true
        },
        component: () => import(/* webpackChunkName: "itticket" */ '../views/admin/page/Ticketing/Index'),
        redirect: { name: 'ticketing' },
        children: [
            {
                path: 'ticketingtracking',
                name: 'ticketingtracking',
                meta: {
                    title: "Ticketing Tracking",
                    show: true
                },
                component: () => import(/* webpackChunkName: "itticket" */ '../views/admin/page/Ticketing/TicketingTracking'),
            },
            {
                path: 'ticketing',
                name: 'ticketing',
                meta: {
                    title: "Ticketing Support",
                    show: true
                },
                component: () => import(/* webpackChunkName: "itticket" */ '../views/admin/page/Ticketing/TicketingSupport'),
            },
            {
                path: 'ticketing/:id',
                name: 'ticketingdetail',
                meta: {
                    title: "Ticketing Support Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "itticket" */ '../views/admin/page/Ticketing/TicketingSupportDetail'),
            },
            {
                path: 'ticketing/:id/:approval/:role',
                name: 'ticketingapproval',
                meta: {
                    title: "Ticketing Support Detail",
                    show: false
                },
                props: true,
                component: () => import(/* webpackChunkName: "itticket" */ '../views/admin/page/Ticketing/TicketingSupportDetail'),
            },
        ]
    }
]